import { render, staticRenderFns } from "./ZahnwerkstattFooter.vue?vue&type=template&id=528ecb3a"
import script from "./ZahnwerkstattFooter.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattFooter.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattFooter.vue?vue&type=style&index=0&id=528ecb3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports